import { hostParts } from '@/lib/host';

/** "Hosted by <name>", and the host's handle on its own line under it when the name ends with one. */
export function HostedBy({ host, className, nameClassName, handleClassName }: { host: string; className?: string; nameClassName?: string; handleClassName?: string }) {
  const { name, handle } = hostParts(host);
  return (
    <>
      <p className={className}>{nameClassName ? <>Hosted by <span className={nameClassName}>{name}</span></> : `Hosted by ${name}`}</p>
      {handle && <p data-part="host-handle" className={handleClassName ?? className}>{handle}</p>}
    </>
  );
}
